import Vue from 'vue'

const state = {
};

const mutations = {
};

const actions = {
    getPriceList: ({ commit }, info) => {
        return Vue.http.get('webstore/price/list')
            .then(res => {
                return res.json();
            }, err => {
                return err.json();
            }).then(data => {
                if (data.error) {
                    return 'error';
                }
                return data;
            })
            .catch(() => {
                return 'error';
            });
    },
};

const getters = {
}

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/priceList.js